import Client, { ClientOption } from "../client";

export default {
  // returns list of all the Car route
  getLiveClassList: (options?: ClientOption) =>
    Client("GET", "live-class", undefined, options),
};
